import { notifications } from '~/app/notifications'
import AppButton from '@theme/components/atom/AppButton'
import AppInput from '@theme/components/atom/AppInput'
import AppTitle from '@theme/components/atom/AppTitle'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import ContactBox from '@theme/components/shop/ContactBox'
import LayoutBase from '@theme/components/shop/LayoutBase'
import LoadingMixin from '~/mixins/LoadingMixin'
import ProvideValidator from '~/app/ProvideValidator'
import RequiredSign from '@theme/components/atom/RequiredSign'
import SeoMixin from '~/mixins/SeoMixin'

export default {
  components: {
    AppButton,
    AppInput,
    AppTitle,
    Breadcrumbs,
    ContactBox,
    LayoutBase,
    RequiredSign,
  },
  mixins: [LoadingMixin, ProvideValidator, SeoMixin],
  head() {
    return this.getSeoHead({ yamlKey: 'PagePasswordForgotten', noindex: true, nofollow: false })
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: this.$t('PagePasswordForgotten.breadcrumbs.index'),
          path: this.localePath({ name: 'passwordForgotten' }),
        },
      ],
      loading: false,
      input: {
        email: '',
      },
    }
  },
  created: function() {
    this.CLASS_ELEMENT = 'col-sm-19 col-lg-20'
    this.CLASS_ELEMENTS_OUTSIDE_NO_LABEL = 'offset-sm-5 offset-lg-4'
    this.CLASS_LABEL = 'col-form-label col-sm-5 col-lg-4'
    this.CLASS_ROW = 'form-group row'
  },
  methods: {
    async submit() {
      this.startLoading()
      this.$validator.validate()
      const response = await this.$store.dispatch('user/REQUEST_NEW_PASSWORD', {
        email: this.input.email,
        callbackUrl: window.location.origin + this.localePath({ name: 'passwordReset' }),
      })
      if (response) {
        this.input.email = ''
        notifications.success(this.$t('PagePasswordForgotten.notifications.success'))
      }
      this.stopLoading()
    },
  },
}
